const vars = {};

vars.server = process.env.REACT_APP_SERVER
  ? process.env.REACT_APP_SERVER
  : "http://localhost:8000";

export default vars;
